import Link from '@mui/material/Link';
import useTheme from '@mui/material/styles/useTheme';
import PropTypes from 'prop-types';
import React from 'react';
import { NavLink } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import { NAVBAR_LINK_CLASS_NAME } from '../../theme/constants/link';

const NavbarLink = ({ id, title, to, onClick, icon, className }) => {
  const theme = useTheme();
  const activeStyle = {
    color: theme.palette.primary.main,
    fontWeight: '500',
  };
  const props = {
    id: { id },
    variant: 'h2',
    className,
  };
  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <Link
        {...props}
        to={to}
        activeStyle={activeStyle}
        component={NavLink}
        onClick={onClick}
      >
        {title}
      </Link>
      {icon && icon}
    </Stack>
  );
};

NavbarLink.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  to: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.element,
  className: PropTypes.string,
};

NavbarLink.defaultProps = {
  to: '/user-login',
  onClick: () => {},
  icon: null,
  className: NAVBAR_LINK_CLASS_NAME,
};

export default NavbarLink;
